<template>
  <div class="container">
    <div class="info">
      <div class="tit">
        <span>c2c{{ $t('tabBar').trade }} </span>
        <div class="right">
          <span @click="$router.push({ name: 'ChatList' })"> <svg-icon class-name="svgs" icon-class="chat" />{{
            $t('c2c').chat }}</span>
          <span @click="$router.push({ name: 'C2cOrder' })"> <svg-icon class-name="svgs" icon-class="history" />{{
            $t('c2c').OrderHistory }}</span>
        </div>
      </div>
      <!-- tab切换 -->
      <div class="tabs">
        <span :class="type == 1 ? 'active' : ''" @click="onSelectType(1)">{{ $t('trade').buyBtn }}</span>
        <span :class="type == 2 ? 'active' : ''" @click="onSelectType(2)">{{ $t('trade').sellBtn }}</span>
      </div>
      <!-- 选择币种 -->
      <div style="width: 220px;">
        <PopoverSelect :items="currencyArr" :onSelect="onSelect">
          <template #reference>
            <div class="selInfo">
              <div class="left">
                <img class="img" :src="require(`@/assets/img/${currency}.png`)" />
                <div class="name">{{ currency }}</div>
              </div>
              <van-icon name="play" size="13" class="ric" color="var(--ntext_color)" />
            </div>
          </template>
        </PopoverSelect>
      </div>
      <!-- 产品列表 -->
      <div class="titles"><span class="name"></span><span>{{ $t('c2c').price }}</span><span>{{ $t('c2c').limit
      }}</span><span>{{ $t('c2c').available }}</span><span></span></div>
      <van-list v-model="loading" :finished="finished" :loading-text="$t('public').loadingText"
        @load="getSalesTemplateList" :immediate-check="false">
        <div class="item" v-for="(item, index) in pList" :key="`ven${index}`">
          <div class="name"><span>{{ item.vendorName.substring(0, 1) }}</span>{{ item.vendorName }}</div>
          <div class="price"><span style="color: var(--text_color);">$</span>{{ item.price }}<span>/USDT</span> </div>
          <!-- 限额 -->
          <div class="limit">{{ item.lowAmount }} &#8209; {{ item.highAmount }} {{ item.currency }}</div>
          <!-- 可用 -->
          <div class="amount">{{ item.usableAmount }} {{ item.currency }}
          </div>
          <!-- 按钮 -->
          <div class="btn" @click="toInfo(item)">
            <span :class="item.type == 1 ? 'greenbg' : 'redbg'">{{ item.type == 1 ?
              $t('trade').buyBtn : $t('trade').sellBtn }}</span>
          </div>
        </div>
      </van-list>
    </div>
  </div>
</template>

<script>
import productApi from '@/api/product'
import systemApi from '@/api/system'
import PopoverSelect from '@/components/popoverSelect.vue'

export default {
  components: {
    PopoverSelect,
  },
  data() {
    return {
      type: 1,
      currencyArr: [],
      currency: 'USDT',
      isRun: false,
      loading: false,
      finished: false,
      parms: {
        pageNum: 1,
        pageSize: 10,
      },
      pList: [],
    }
  },
  mounted() {
    window.scrollTo(0, 0);
    this.getCurrencyNetworkSetting()
    this.getSalesTemplateList()
  },
  methods: {
    //获取系统币种
    async getCurrencyNetworkSetting() {
      const res = await systemApi.getCurrencyNetworkSetting()
      this.currencyArr = res.currencyArr.split(',').map(item => ({ text: item }))
    },
    //选择类型
    async onSelectType(val) {
      this.type = val
      this.refreshList()
    },
    //选择币种
    async onSelect(action) {
      this.currency = action.text
      this.refreshList()
    },
    // 去买入/卖出
    toInfo(item) {
      if (item.type == 1)
        this.$router.push({ name: 'C2cBuy', query: { id: item.vendorSalesTemplateId } })
      if (item.type == 2)
        this.$router.push({ name: 'C2cSell', query: { id: item.vendorSalesTemplateId } })
    },
    //刷新获取列表
    refreshList() {
      this.pList = []
      this.parms.pageNum = 1
      this.finished = false;
      this.getSalesTemplateList()
    },
    // 获取产品列表
    async getSalesTemplateList() {
      if (this.isRun) return
      this.isRun = true
      this.parms.type = this.type
      this.parms.currency = this.currency
      const res = await productApi.getSalesTemplateList(this.parms)
      this.pList.push(...res.rows);
      this.isRun = false
      this.parms.pageNum++
      // 加载状态结束
      this.loading = false;
      // 数据全部加载完成
      if (this.pList.length >= res.total)
        this.finished = true;
    },
  }
}
</script>

<style lang="less" scoped>
.container {
  min-height: 100vh;
  padding-top: 110px;
  width: 100%;
  background: var(--background_color);

  .info {
    margin: 0 auto;
    max-width: 1280px;

    .tit {
      font-size: 36px;
      font-weight: bold;
      color: var(--text_color);
      padding-bottom: 40px;
      border-bottom: 1px solid var(--info_color);
      display: flex;
      align-items: center;
      justify-content: space-between;

      .right {
        display: flex;
        align-items: center;

        span {
          font-size: 14px;
          font-weight: normal;
          color: var(--text_color);
          margin-left: 30px;

          &:hover {
            opacity: 0.8;
          }

          .svgs {
            width: 15px;
            height: 15px;
            color: var(--text_color);
            margin-right: 5px;
          }
        }
      }
    }

    .tabs {
      margin-top: 40px;
      padding: 15px 0;
      font-size: 16px;
      color: var(--ntext_color);

      span {
        margin-right: 30px;
      }

      .active {
        font-weight: bold;
        color: var(--text_color);
        padding-bottom: 13px;
        border-bottom: 2px solid var(--text_color);
      }
    }

    .selInfo {
      margin-top: 20px;
      display: flex;
      align-items: center;
      justify-content: space-between;
      border-radius: 8px;
      border: 1px solid var(--info_color);
      background: var(--info_color);
      width: 220px;
      padding: 10px 15px;

      &:hover {
        border: 1px solid var(--text_color);
      }

      .left {
        display: flex;
        align-items: center;

        .img {
          width: 20px;
          height: 20px;
          border-radius: 50%;
        }

        .name {
          margin: 0 5px;
          font-size: 14px;
          color: var(--text_color);
        }

      }

      .ric {
        transform: rotate(90deg);
      }

    }

    .titles {
      padding: 30px 15px;
      border-bottom: 1px solid var(--info_color);
      font-size: 12px;
      color: var(--ntext_color);
      display: flex;
      align-items: center;
      justify-content: space-between;

      .name {
        width: 30%;
      }

      span {
        width: 15%;
      }
    }

    .item {
      padding: 30px 15px;
      display: flex;
      align-items: center;
      justify-content: space-between;
      border-bottom: 1px solid var(--info_color);

      &:hover {
        background: var(--info_color);
      }

      .name {
        width: 30%;
        font-size: 15px;
        font-weight: bold;
        color: var(--text_color);
        display: flex;
        align-items: center;

        span {
          background: var(--text_color);
          width: 30px;
          height: 30px;
          border-radius: 50%;
          margin-right: 10px;
          font-size: 16px;
          color: var(--background_color);
          font-weight: normal;
          display: flex;
          align-items: center;
          justify-content: center;
        }
      }

      .price {
        width: 15%;
        font-size: 22px;
        font-weight: bold;
        color: var(--text_color);

        span {
          margin-left: 5px;
          font-size: 12px;
          color: var(--ntext_color);
          font-weight: normal;
        }
      }

      .limit {
        width: 15%;
        font-size: 13px;
        color: var(--text_color);
      }

      .amount {
        width: 15%;
        font-size: 13px;
        color: var(--text_color);
      }

      .btn {
        width: 15%;
        display: flex;
        justify-content: right;

        &:hover {
          opacity: 0.8;
        }

        span {
          padding: 10px 30px;
          border-radius: 30px;
          font-size: 13px;
          font-weight: normal;
          color: #fff;
        }
      }
    }
  }

}
</style>
